/**
 * Whether the player fullscreen control should be shown.
 * Hidden by default; URL param fsmode=true (or 1, on, yes) shows the button.
 */
export function isFullscreenModeEnabled(search) {
  const query =
    search ??
    (typeof window !== "undefined" ? window.location.search : "");
  const params = new URLSearchParams(query);
  const value = params.get("fsmode");
  if (value == null) return true;
  if (value === true || value === 1) return true;
  if (typeof value === "string") {
    const s = value.trim().toLowerCase();
    if (s === "1" || s === "true" || s === "yes" || s === "on") return true;
    if (s === "0" || s === "false" || s === "no" || s === "off") return false;
  }
  return false;
}
